if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantInput = this.form.querySelector('[name=id]');
      this.variantInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      this.defaultSubmitButtonText = this.submitButtonText?.textContent;

      if (this.dataset.requireSizeSelection === 'true') {
        this.variantInput.addEventListener('change', this.clearSizeSelectionError.bind(this));
      }
    }

    normalizeTeam(team_tag){
      let team = team_tag;
      const upcaseNames = ['pga', 'liv', 'us', 'ac', 'bc','cf', 'fc', 'gc','sc', 'xi', 'xii', 'xiii', 'byu','la', 'lsu', 'wnba','mlb','nfl','nba','milb', 'nascar','rcr', 'tcu', 'usa','am', 'ucla','usc','twenty', 'thirty', 'forty', 'fifty']
      const replaceNames = [['4aces','4Aces'], ['a-frame','A-Frame'], ['hyflyers', 'HyFlyers'], ['mclaren','McLaren'],['rangegoats', 'RangeGoats'],['d.c.', 'D.C.'],['66ers', '66Ers'],['89ers', '89Ers'],['a&m','A&M']]

      team = team_tag?.toLowerCase().split(' ')?.map(word => {
          if(word === 'none') return ''

          const nameToReplace = replaceNames.find(name => word === name[0])
          const upcaseName = upcaseNames.some(name => name === word)
          if(nameToReplace){
            return word.replace(nameToReplace[0], nameToReplace[1])
          } else if(upcaseName){
            return word.toUpperCase()
          } else{
            return word.charAt(0)?.toUpperCase() + word.slice(1)
          }
      })?.join(' ') || team_tag;
      return team
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.submitButton;
      if (submitButton.classList.contains('loading')) return;

      if (this.dataset.requireSizeSelection === 'true' && !this.variantInput.value) {
        this.showSizeSelectionError();
        return;
      }

      this.handleErrorMessage();
      this.cartNotification?.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification?.getSectionsToRender().map((section) => section.id));

      formData.append('sections_url', window.location.pathname);
      formData.append('tags', window.location.pathname);

      config.body = formData;
      let itemAdded = false;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          itemAdded = true;
          this.cartNotification.renderContents(response);

          // added for minicart
          const cartBubble = document.querySelector('.ba-cart__bubble span');
          const miniCartItemCounter = document.querySelector('#mini-cart .ba-cart__title span');
          const toastNotificationCounter = document.querySelector('#minicart-toast-notification .view-bag-btn span');

          function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
          }

          fetch('/cart.json')
          .then(response => {
            return response.json();
          }).then((data) => {
            if(window.gift_with_purchase?.available) {
              document.querySelector('cart-items').addOrRemoveGiftToCart(data);
            }

            // Counts come from the cart itself. These used to scrape
            // .cart-count-bubble, which Liquid only renders once the cart is
            // non-empty (and header V3 never renders at all) — so adding to an
            // empty bag read undefined and printed "Bag (undefined)".
            const count = data.item_count;
            if(cartBubble) {
              cartBubble.textContent = pad(count, 2);
            }
            if(miniCartItemCounter) {
              miniCartItemCounter.textContent = count === 0 ? '' : `(${count})`;
            }
            if(toastNotificationCounter) {
              toastNotificationCounter.textContent = count > 9 ? '(9+)' : `(${count})`;
            }

            document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: data}}))
          }).catch((error) => {
            console.error('Error:', error);
          });

          document.querySelector('cart-items')?.classList.toggle('is-empty', response.quantity === 0);
          document.getElementById('main-cart-items')?.classList.toggle('is-empty', response.quantity === 0);
          document.getElementById('main-cart-footer')?.classList.toggle('is-empty', response.quantity === 0);
          document.querySelector('.cart-promotions')?.classList.toggle('is-empty', response.quantity === 0);

          return response;
        })
        .then((response) => {
          if (!response) return;

          let  recsContainer = document.querySelector('#cart-product-recommendations');
          let recsCardsContainer = document.querySelector('#cart-product-recommendations #slider--cart');
          recsContainer.setAttribute('product-id', response.product_id);

          let url = recsContainer.dataset.url + response.product_id;
          addRecommendationsToMiniCart(recsContainer, recsCardsContainer, url);

          if(window.innerWidth < 768){
            return ;
          }

          let cartToastNotification = document.querySelector('#minicart-toast-notification');

          if(cartToastNotification) {
            if(cartToastNotification.dataset.showCartNotification === 'true'){
              if (typeof window.setMiniCartToastNotificationOpen === 'function') {
                window.setMiniCartToastNotificationOpen(true);
              } else {
                cartToastNotification?.classList.remove('hidden');
              }
            }
            let productTitle = document.querySelector('#minicart-toast-notification .ba-cartItems__item-title'),
              productVendor = document.querySelector('#minicart-toast-notification .ba-cartItems__item-vendor'),
              productOption = document.querySelector('#minicart-toast-notification .product-option dd'),
              productPrice = document.querySelector('#minicart-toast-notification .pn-price-item');

              if(productOption) productOption.textContent = response.variant_title;
              if(productPrice) productPrice.textContent = formatToMoneyPrice(response.final_price);

              fetch(`/products/${response.handle}.json`)
              .then(response => response.json())
              .then(response => {
                const team_tags = response?.tags?.filter(function (str) { return str?.includes('team:'); });
                const team_tag = team_tags?.length > 0 && team_tags[0].toLowerCase().replace('team:', '');
                const team = team_tag ? this.normalizeTeam(team_tag) : null
                if(team) productVendor.textContent = team;
                const regex = /\b(\d+)([a-zA-Z]{5,})\b/gi;
                let displayTitle = response?.title?.replace(team?.trim(), '');
                displayTitle = displayTitle?.replace(regex, '<b>$1</b>$2')
                displayTitle = displayTitle?.replace(/\u00AE/g, '<sup class="trademark">\u00AE</sup>')
                if(displayTitle) productTitle.innerHTML = displayTitle
            })
            .catch(err =>{
              productVendor.textContent = '';
              console.log(err);
            });

            setTimeout(() => {
              if (typeof window.setMiniCartToastNotificationOpen === 'function') {
                window.setMiniCartToastNotificationOpen(false);
              } else {
                cartToastNotification?.classList.add('hidden');
              }
            }, 5000);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (!itemAdded) return;

          if(window.innerWidth >= 768 && document.querySelector('#minicart-toast-notification')?.dataset?.showCartNotification === 'true'){
            return ;
          }

          // added for minicart
          document.querySelector('body')?.classList.add('overflow-hidden');
          const miniCart = document.querySelector('#mini-cart');
          if (miniCart) {
            miniCart.classList.add('mini-cart--open');
            trapFocus(miniCart, miniCart.querySelector('.mini-cart__close'));
            document.querySelector('.mini-cart-overlay')?.classList.add('mini-cart-overlay--open');

          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    showSizeSelectionError() {
      this.submitButton.setAttribute('aria-invalid', 'true');
      this.submitButtonText.textContent = this.dataset.selectSizeMessage;
    }

    clearSizeSelectionError() {
      if (!this.submitButton.hasAttribute('aria-invalid')) return;

      this.submitButton.removeAttribute('aria-invalid');
      this.submitButtonText.textContent = this.defaultSubmitButtonText;
    }
  });
}
